module.exports = __webpack_public_path__ + "static/img/lcc.7244fc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lcc.jpg
// module id = HBuS
// module chunks = 1